export default "__VITE_ASSET__BFJbVcsO__"